import PaginationURL from "util/PaginationURL";
import { DATA_LAKE_API_ROUTES } from "data-lake/Constants";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
const fetchDataLakeStreams = ({ page, perPage, query }) => {
  const paginatedURL = PaginationURL(
    DATA_LAKE_API_ROUTES.DataLakeAPIController.paginatedStreams().url,
    page,
    perPage,
    query,
    {
      sort: "stream_id",
      order: "asc"
    }
  );
  return fetch("GET", qualifyUrl(paginatedURL));
};
export default fetchDataLakeStreams;
